<template>
  <div class="app-logo">
    <img :src="logoUrl" :alt="$t('alt.portalLogo')" :height="height" />
  </div>
</template>

<script lang="ts" setup>
import appConfig from '@/constants/appConfig'

const { logoUrl, height } = defineProps({
  logoUrl: {
    type: String,
    default: appConfig.APP_LOGO,
  },
  height: {
    type: String,
    default: '45px',
  },
})
</script>

<style lang="scss" scoped>
.app-logo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
